import React from "react";

export const ADD_CLUB_SVG = (
  <svg
    style={{ minWidth: "20px" }}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.5 10C18.5 14.6944 14.6944 18.5 10 18.5C5.30558 18.5 1.5 14.6944 1.5 10C1.5 5.30558 5.30558 1.5 10 1.5C14.6944 1.5 18.5 5.30558 18.5 10ZM20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10ZM9.25 5.75C9.25 5.33579 9.58579 5 10 5C10.4142 5 10.75 5.33579 10.75 5.75V9.25H14.25C14.6642 9.25 15 9.58579 15 10C15 10.4142 14.6642 10.75 14.25 10.75H10.75V14.25C10.75 14.6642 10.4142 15 10 15C9.58579 15 9.25 14.6642 9.25 14.25V10.75H5.75C5.33579 10.75 5 10.4142 5 10C5 9.58579 5.33579 9.25 5.75 9.25H9.25V5.75Z"
      fill="#DA052C"
    />
  </svg>
);

export const LOG_IN_SVG = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.4331 5C13.4331 6.84095 11.8961 8.33333 10.0001 8.33333C8.10412 8.33333 6.56711 6.84095 6.56711 5C6.56711 3.15905 8.10412 1.66667 10.0001 1.66667C11.8961 1.66667 13.4331 3.15905 13.4331 5ZM15.1496 5C15.1496 7.76142 12.8441 10 10.0001 10C7.15612 10 4.8506 7.76142 4.8506 5C4.8506 2.23858 7.15612 0 10.0001 0C12.8441 0 15.1496 2.23858 15.1496 5ZM18.2791 19.3081C18.3838 19.7046 18.7404 20 19.162 20C19.6934 20 20.1026 19.5398 19.9772 19.0384C18.8375 14.4803 14.8027 11.1111 10 11.1111C5.19733 11.1111 1.16247 14.4803 0.0227658 19.0384C-0.102603 19.5398 0.306599 20 0.837986 20C1.25958 20 1.6162 19.7046 1.72089 19.3081C2.72685 15.498 6.11019 12.7778 10 12.7778C13.8898 12.7778 17.2732 15.498 18.2791 19.3081Z"
      fill="#DA052C"
    />
  </svg>
);

export const MENU_BUTTON_SVG = (
  <svg
    width="18"
    height="12"
    viewBox="0 0 18 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1 2C0.447716 2 0 1.55229 0 1C0 0.447716 0.447715 0 1 0H17C17.5523 0 18 0.447715 18 1C18 1.55228 17.5523 2 17 2L1 2Z"
      fill="white"
    />
    <path
      d="M1 7C0.447716 7 0 6.55229 0 6C0 5.44772 0.447715 5 1 5L17 5C17.5523 5 18 5.44772 18 6C18 6.55228 17.5523 7 17 7L1 7Z"
      fill="white"
    />
    <path
      d="M0 11C0 11.5523 0.447716 12 1 12H17C17.5523 12 18 11.5523 18 11C18 10.4477 17.5523 10 17 10H1C0.447715 10 0 10.4477 0 11Z"
      fill="white"
    />
  </svg>
);

export const CLOSE_WHITE_SVG = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M18 6L12 12L18 18" stroke="white" strokeWidth="2"></path>
    <path d="M6 6L12 12L6 18" stroke="white" strokeWidth="2"></path>
  </svg>
);

export const PLUS_WHITE_SVG = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width="24px"
    height="24px"
  >
    <path
      fillRule="evenodd"
      d="M 11 2 L 11 11 L 2 11 L 2 13 L 11 13 L 11 22 L 13 22 L 13 13 L 22 13 L 22 11 L 13 11 L 13 2 Z"
      fill="white"
    />
  </svg>
);

export const CHECK_MARK_WHITE_SVG = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="24"
    viewBox="0 0 24 24"
    width="24"
  >
    <path d="M0 0h24v24H0z" fill="none" />
    <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" fill="white" />
  </svg>
);

export const CLOSE_SVG = (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.6554 0.344595C13.1959 -0.114864 12.451 -0.114864 11.9916 0.344595L7 5.33615L2.00845 0.344595C1.54899 -0.114865 0.804055 -0.114865 0.344596 0.344595C-0.114864 0.804054 -0.114864 1.54899 0.344595 2.00845L5.33615 7L0.344595 11.9916C-0.114865 12.451 -0.114865 13.1959 0.344595 13.6554C0.804055 14.1149 1.54899 14.1149 2.00845 13.6554L7 8.66385L11.9916 13.6554C12.451 14.1149 13.1959 14.1149 13.6554 13.6554C14.1149 13.1959 14.1149 12.451 13.6554 11.9916L8.66385 7L13.6554 2.00845C14.1149 1.54899 14.1149 0.804056 13.6554 0.344595Z"
      fill="white"
    />
  </svg>
); // MainNavBar.js

// NavBarCity.js
export const CITY_ICON_SVG = (
  <svg
    width="15"
    height="20"
    viewBox="0 0 15 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.5 20C7.7474 20.0004 7.98177 19.8905 8.14005 19.7009C8.84196 18.8603 15 11.3717 15 7.5C15 3.35815 11.6423 0 7.5 0C3.35815 0 0 3.35815 0 7.5C0 11.3717 6.15845 18.8603 6.85994 19.7009C7.01864 19.8905 7.25301 20.0004 7.5 20ZM7.5 1.66667C10.7202 1.67114 13.3293 4.28019 13.3333 7.5C13.3333 9.98413 9.57357 15.2336 7.5 17.8451C5.42603 15.2344 1.66667 9.98698 1.66667 7.5C1.67114 4.28019 4.28019 1.67114 7.5 1.66667Z"
      fill="#DA052C"
    />
    <path
      d="M10.8334 6.66669C10.8334 4.82586 9.34126 3.33333 7.50002 3.33333C5.65919 3.33333 4.16667 4.82586 4.16667 6.66669C4.16667 8.50793 5.65919 10 7.50002 10C9.34126 10 10.8334 8.50793 10.8334 6.66669ZM5.83334 6.66669C5.83334 5.74627 6.5796 5.00001 7.50002 5.00001C8.42084 5.00001 9.1667 5.74627 9.1667 6.66669C9.1667 7.58751 8.42084 8.33336 7.50002 8.33336C6.5796 8.33336 5.83334 7.58751 5.83334 6.66669Z"
      fill="#DA052C"
    />
  </svg>
); // NavBarCity.js

export const DROP_SVG = (
  <svg
    className="drop-svg"
    width="11"
    height="5"
    viewBox="0 0 11 5"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.7075 0L5.5 3.09042L1.2925 0L0 0.951417L5.5 5L11 0.951417L9.7075 0Z"
      fill="#2B2B2C"
    />
  </svg>
);

export const SLIDER_PREV_BUTTON_SVG = (color) => (
  <svg
    width="8"
    height="22"
    viewBox="0 0 8 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 20.0333L6.78663 22L0 11L6.78663 0L8 1.96667L2.42673 11L8 20.0333H8Z"
      fill={color ? color : "white"}
    />
  </svg>
);

export const SLIDER_NEXT_BUTTON_SVG = (color) => (
  <svg
    width="8"
    height="22"
    viewBox="0 0 8 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 20.0333L1.21337 22L8 11L1.21337 0L0 1.96667L5.57327 11L0 20.0333H0Z"
      fill={color ? color : "white"}
    />
  </svg>
);

export const SEARCH_SVG = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.4788 14.6175C12.0577 15.756 10.2496 16.4377 8.28112 16.4377C3.70758 16.4377 0 12.758 0 8.21883C0 3.67969 3.70758 0 8.28112 0C12.8546 0 16.5622 3.67969 16.5622 8.21883C16.5622 10.2493 15.8203 12.1078 14.5909 13.5419L19.7726 18.6846C20.0758 18.9856 20.0758 19.4734 19.7726 19.7743C19.4694 20.0752 18.9779 20.0752 18.6747 19.7743L13.4788 14.6175ZM15.0095 8.21883C15.0095 11.9069 11.9971 14.8966 8.28112 14.8966C4.56512 14.8966 1.55271 11.9069 1.55271 8.21883C1.55271 4.53078 4.56512 1.54103 8.28112 1.54103C11.9971 1.54103 15.0095 4.53078 15.0095 8.21883Z"
      fill="#DA052C"
    />
  </svg>
);

export const MAP_SVG = (
  <svg
    width="17"
    height="22"
    viewBox="0 0 17 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.9526 20.2955L13.3163 14.7182C13.2637 14.6069 13.1725 14.5216 13.0632 14.4751L11.7516 13.8911L14.0242 10.0818C14.0296 10.0727 14.0347 10.0634 14.0396 10.054C14.4914 9.172 14.7205 8.21891 14.7205 7.22137C14.7205 5.54329 14.0626 3.97009 12.8679 2.79161C11.6733 1.61341 10.0908 0.97704 8.41194 1.00063C6.78137 1.02325 5.24611 1.67829 4.08888 2.84516C2.93177 4.01196 2.2892 5.5527 2.27951 7.18368C2.27358 8.18036 2.50905 9.17286 2.96032 10.054C2.96516 10.0634 2.97028 10.0727 2.97571 10.0818L5.24822 13.8911L3.9291 14.4782C3.82118 14.5262 3.73408 14.6113 3.68362 14.7181L1.04737 20.2955C0.959141 20.4821 0.996363 20.7039 1.14064 20.8514C1.28488 20.9989 1.50563 21.0412 1.69416 20.9573L4.99677 19.4868L8.29937 20.9573C8.42713 21.0141 8.57301 21.0141 8.70077 20.9573L12.0034 19.4868L15.306 20.9573C15.3705 20.986 15.4388 21 15.5065 21C15.6366 21 15.7646 20.9485 15.8595 20.8514C16.0037 20.7039 16.0408 20.4821 15.9526 20.2955ZM3.83161 9.59008C3.45158 8.84274 3.26141 8.0352 3.26645 7.18958C3.28317 4.36032 5.59762 2.02669 8.42568 1.98751C9.83823 1.96852 11.17 2.50309 12.1749 3.49438C13.1802 4.48591 13.7337 5.8095 13.7337 7.22141C13.7337 8.05575 13.5436 8.85254 13.1685 9.59008L8.92378 16.7052C8.79419 16.9224 8.5843 16.9459 8.50005 16.9459C8.41576 16.9459 8.20587 16.9224 8.07632 16.7052L3.83161 9.59008ZM12.204 18.4957C12.0762 18.4389 11.9303 18.4389 11.8026 18.4957L8.49997 19.9663L5.19737 18.4957C5.06961 18.4389 4.92373 18.4389 4.79597 18.4957L2.50808 19.5145L4.49758 15.3055L5.75749 14.7448L7.2287 17.2109C7.49835 17.6629 7.9736 17.9328 8.49989 17.9328C9.02619 17.9328 9.50144 17.6629 9.77109 17.2109L11.2423 14.7448L12.5023 15.3058L14.4917 19.5145L12.204 18.4957Z"
      fill="#DA052C"
    />
    <path
      d="M8.50017 4.96903C7.25838 4.96903 6.24816 5.97938 6.24816 7.22129C6.24816 8.46321 7.25838 9.47356 8.50017 9.47356C9.74192 9.4736 10.7521 8.46321 10.7521 7.22129C10.7521 5.97938 9.74192 4.96903 8.50017 4.96903ZM8.50017 8.48661C7.80257 8.48665 7.23498 7.91907 7.23498 7.22129C7.23498 6.5236 7.80253 5.95598 8.50017 5.95598C9.19777 5.95598 9.76531 6.5236 9.76531 7.22129C9.76531 7.91899 9.19777 8.48661 8.50017 8.48661Z"
      fill="#DA052C"
    />
    <path
      d="M15.9526 20.2955L13.3163 14.7182C13.2637 14.6069 13.1725 14.5216 13.0632 14.4751L11.7516 13.8911L14.0242 10.0818C14.0296 10.0727 14.0347 10.0634 14.0396 10.054C14.4914 9.172 14.7205 8.21891 14.7205 7.22137C14.7205 5.54329 14.0626 3.97009 12.8679 2.79161C11.6733 1.61341 10.0908 0.97704 8.41194 1.00063C6.78137 1.02325 5.24611 1.67829 4.08888 2.84516C2.93177 4.01196 2.2892 5.5527 2.27951 7.18368C2.27358 8.18036 2.50905 9.17286 2.96032 10.054C2.96516 10.0634 2.97028 10.0727 2.97571 10.0818L5.24822 13.8911L3.9291 14.4782C3.82118 14.5262 3.73408 14.6113 3.68362 14.7181L1.04737 20.2955C0.959141 20.4821 0.996363 20.7039 1.14064 20.8514C1.28488 20.9989 1.50563 21.0412 1.69416 20.9573L4.99677 19.4868L8.29937 20.9573C8.42713 21.0141 8.57301 21.0141 8.70077 20.9573L12.0034 19.4868L15.306 20.9573C15.3705 20.986 15.4388 21 15.5065 21C15.6366 21 15.7646 20.9485 15.8595 20.8514C16.0037 20.7039 16.0408 20.4821 15.9526 20.2955ZM3.83161 9.59008C3.45158 8.84274 3.26141 8.0352 3.26645 7.18958C3.28317 4.36032 5.59762 2.02669 8.42568 1.98751C9.83823 1.96852 11.17 2.50309 12.1749 3.49438C13.1802 4.48591 13.7337 5.8095 13.7337 7.22141C13.7337 8.05575 13.5436 8.85254 13.1685 9.59008L8.92378 16.7052C8.79419 16.9224 8.5843 16.9459 8.50005 16.9459C8.41576 16.9459 8.20587 16.9224 8.07632 16.7052L3.83161 9.59008ZM12.204 18.4957C12.0762 18.4389 11.9303 18.4389 11.8026 18.4957L8.49997 19.9663L5.19737 18.4957C5.06961 18.4389 4.92373 18.4389 4.79597 18.4957L2.50808 19.5145L4.49758 15.3055L5.75749 14.7448L7.2287 17.2109C7.49835 17.6629 7.9736 17.9328 8.49989 17.9328C9.02619 17.9328 9.50144 17.6629 9.77109 17.2109L11.2423 14.7448L12.5023 15.3058L14.4917 19.5145L12.204 18.4957Z"
      stroke="#DA052C"
      strokeWidth="0.5"
    />
    <path
      d="M8.50017 4.96903C7.25838 4.96903 6.24816 5.97938 6.24816 7.22129C6.24816 8.46321 7.25838 9.47356 8.50017 9.47356C9.74192 9.4736 10.7521 8.46321 10.7521 7.22129C10.7521 5.97938 9.74192 4.96903 8.50017 4.96903ZM8.50017 8.48661C7.80257 8.48665 7.23498 7.91907 7.23498 7.22129C7.23498 6.5236 7.80253 5.95598 8.50017 5.95598C9.19777 5.95598 9.76531 6.5236 9.76531 7.22129C9.76531 7.91899 9.19777 8.48661 8.50017 8.48661Z"
      stroke="#DA052C"
      strokeWidth="0.5"
    />
  </svg>
);

export const TAXI_SVG = (
  <svg
    width="25"
    height="13"
    viewBox="0 0 25 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M24.9662 10.5094L22.3362 2.15206C22.2697 0.954897 21.2229 0 19.9463 0H5.05319C3.77633 0 2.72979 0.954645 2.66303 2.15206L0.0332447 10.5094C0.0111702 10.5799 0 10.6529 0 10.7264C0 11.9802 1.07394 13 2.39362 13H22.6064C23.9263 13 25 11.9802 25 10.7264C24.9995 10.6529 24.9886 10.5799 24.9662 10.5094ZM22.6059 11.4843H2.39309C1.9859 11.4843 1.6492 11.1933 1.60106 10.8186L4.22181 2.49057C4.24388 2.42008 4.25505 2.34708 4.25505 2.27357C4.25505 1.85574 4.61303 1.51571 5.05293 1.51571H19.9463C20.3862 1.51571 20.7441 1.85574 20.7441 2.27357C20.7441 2.34708 20.7551 2.42008 20.7774 2.49057L23.3981 10.8186C23.3497 11.1933 23.0133 11.4843 22.6059 11.4843Z"
      fill="#DA052C"
    />
    <path
      d="M9.30904 4.25132H5.28112V5.32823H6.64787V8.74868H7.94867V5.32823H9.30904V4.25132Z"
      fill="#DA052C"
    />
    <path
      d="M10.6559 4.25132L9.00878 8.74868H10.3359L10.616 7.86831H11.8761L12.1628 8.74868H13.4832L11.8428 4.25132H10.6559ZM10.8093 7.04477L11.2497 5.65133L11.6694 7.04477H10.8093Z"
      fill="#DA052C"
    />
    <path
      d="M16.6043 4.25132L15.7441 5.67053L14.8838 4.25132H13.4766L15.0574 6.53196L13.5301 8.74868H14.937L15.7441 7.39313L16.5508 8.74868H17.9513L16.4239 6.53196L18.0048 4.25132H16.6043Z"
      fill="#DA052C"
    />
    <path
      d="M19.7184 4.25132H18.4181V8.74868H19.7184V4.25132Z"
      fill="#DA052C"
    />
  </svg>
);

export const GO_BACK_SVG = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.75 9.25C15.1642 9.25 15.5 9.58579 15.5 10C15.5 10.4142 15.1642 10.75 14.75 10.75H7.48227L9.20714 12.4749C9.50004 12.7678 9.50004 13.2426 9.20714 13.5355C8.91425 13.8284 8.43937 13.8284 8.14648 13.5355L5.24734 10.6364C4.89587 10.2849 4.89587 9.71508 5.24734 9.3636L8.14648 6.46447C8.43937 6.17157 8.91425 6.17157 9.20714 6.46447C9.50004 6.75736 9.50004 7.23223 9.20714 7.52513L7.48227 9.25H14.75Z"
      fill="#2B2B2C"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20ZM10 18.5C14.6944 18.5 18.5 14.6944 18.5 10C18.5 5.30558 14.6944 1.5 10 1.5C5.30558 1.5 1.5 5.30558 1.5 10C1.5 14.6944 5.30558 18.5 10 18.5Z"
      fill="#2B2B2C"
    />
  </svg>
);

export const SUCCESS_SVG = (
  <svg
    width="78"
    height="78"
    viewBox="0 0 78 78"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M39 74.1C58.3852 74.1 74.1 58.3852 74.1 39C74.1 19.6148 58.3852 3.9 39 3.9C19.6148 3.9 3.9 19.6148 3.9 39C3.9 58.3852 19.6148 74.1 39 74.1ZM39 78C60.5391 78 78 60.5391 78 39C78 17.4609 60.5391 0 39 0C17.4609 0 0 17.4609 0 39C0 60.5391 17.4609 78 39 78Z"
      fill="var(--secondaryTextColor, #DA052C)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M57.7155 23.7865C58.579 24.4303 58.7571 25.652 58.1133 26.5154L37.76 53.8154C37.4185 54.2735 36.8932 54.5588 36.323 54.5958C35.7528 54.6328 35.195 54.4179 34.7972 54.0078L22.0005 40.8185C21.2505 40.0456 21.2692 38.8111 22.0421 38.0611C22.8151 37.3112 24.0496 37.3298 24.7995 38.1028L36.0019 49.6487L54.9867 24.1843C55.6304 23.3209 56.8521 23.1428 57.7155 23.7865Z"
      fill="var(--secondaryTextColor, #DA052C)"
    />
  </svg>
);

export const NOSUCCESS_SVG = (
  <svg
    viewBox="0 0 128 128"
    width="78"
    height="78"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill="var(--secondaryTextColor, #DA052C)"
      d="M64,0a64,64,0,1,0,64,64A64.07,64.07,0,0,0,64,0Zm0,122a58,58,0,1,1,58-58A58.07,58.07,0,0,1,64,122Z"
    />
    <path
      fill="var(--secondaryTextColor, #DA052C)"
      d="M92.12,35.79a3,3,0,0,0-4.24,0L64,59.75l-23.87-24A3,3,0,0,0,35.88,40L59.76,64,35.88,88a3,3,0,0,0,4.25,4.24L64,68.25l23.88,24A3,3,0,0,0,92.13,88L68.24,64,92.13,40A3,3,0,0,0,92.12,35.79Z"
    />
  </svg>
);

export const ONLINE_REGISTRATION_SVG = (
  <svg
    width="62"
    height="62"
    viewBox="0 0 62 62"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M60.1211 37.398C60.6065 37.398 61 37.0046 61 36.5191V17.8375C61 15.4143 59.0287 13.443 56.6055 13.443H47.387V5.39453C47.387 2.97133 45.4157 1 42.9925 1H19.0075C16.5843 1 14.613 2.97133 14.613 5.39453V13.443H5.39453C2.97133 13.443 1 15.4143 1 17.8375V47.6781C1 50.1013 2.97133 52.0727 5.39453 52.0727H26.6959V55.7266H25.5856C23.3563 55.7266 21.5426 57.5403 21.5426 59.7695C21.5426 60.448 22.0946 61 22.7731 61H39.2268C39.9053 61 40.4573 60.448 40.4573 59.7695C40.4573 57.5403 38.6436 55.7266 36.4143 55.7266H35.3039V52.0727H56.6055C59.0287 52.0727 61 50.1013 61 47.6781V40.6205C61 40.135 60.6065 39.7416 60.1211 39.7416C59.6357 39.7416 59.2422 40.135 59.2422 40.6205V47.6781C59.2422 49.132 58.0594 50.3148 56.6055 50.3148H34.4342C34.4311 50.3148 34.4282 50.3144 34.4252 50.3144C34.4221 50.3144 34.4192 50.3148 34.4161 50.3148H27.584C27.5809 50.3148 27.578 50.3144 27.575 50.3144C27.5719 50.3144 27.569 50.3148 27.5659 50.3148H5.39453C3.94059 50.3148 2.75781 49.132 2.75781 47.6781V17.8375C2.75781 16.3837 3.94059 15.2008 5.39453 15.2008H14.613V16.9586H5.74609C5.06758 16.9586 4.51562 17.5105 4.51562 18.1891V47.6781C4.51562 48.1636 4.90914 48.557 5.39453 48.557H56.2539C56.9324 48.557 57.4844 48.0051 57.4844 47.3266V18.1891C57.4844 17.5105 56.9324 16.9586 56.2539 16.9586H47.387V15.2008H56.6055C58.0594 15.2008 59.2422 16.3837 59.2422 17.8375V36.5191C59.2422 37.0045 59.6357 37.398 60.1211 37.398ZM28.4538 52.0727H33.5462V55.7266H28.4538V52.0727ZM36.4144 57.4844C37.493 57.4844 38.3994 58.2354 38.6382 59.2422H23.3618C23.6005 58.2354 24.507 57.4844 25.5856 57.4844H36.4144ZM14.613 46.7992H6.27344V18.7164H14.613V46.7992ZM45.6292 46.7992H16.3708V5.39453C16.3708 3.9407 17.5536 2.75781 19.0075 2.75781H42.9925C44.4464 2.75781 45.6292 3.9407 45.6292 5.39453V46.7992ZM55.7266 18.7164V46.7992H47.387V18.7164H55.7266ZM41.12 32.7578H20.88C20.3946 32.7578 20.0011 33.1512 20.0011 33.6367C20.0011 34.1222 20.3946 34.5156 20.88 34.5156H41.12C41.6053 34.5156 41.9989 34.1222 41.9989 33.6367C41.9989 33.1512 41.6053 32.7578 41.12 32.7578ZM31 6.27344C28.5554 6.27344 26.2289 7.04734 24.2723 8.51172C23.8837 8.80246 23.8043 9.35348 24.0952 9.74195C24.3861 10.1305 24.9368 10.21 25.3255 9.91914C26.9758 8.68398 28.938 8.03125 31 8.03125C36.2341 8.03125 40.4922 12.2895 40.4922 17.5234C40.4922 22.7574 36.2341 27.0156 31 27.0156C25.7659 27.0156 21.5078 22.7574 21.5078 17.5234C21.5078 15.827 21.9627 14.1613 22.8235 12.7063C23.0706 12.2887 22.9323 11.7496 22.5146 11.5025C22.0968 11.2554 21.5577 11.3936 21.3106 11.8115C20.2896 13.5371 19.75 15.5124 19.75 17.5234C19.75 23.7268 24.7967 28.7734 31 28.7734C37.2033 28.7734 42.25 23.7268 42.25 17.5234C42.25 11.3201 37.2033 6.27344 31 6.27344ZM26.9505 22.0475C28.1752 23.2836 30.2764 23.2923 31.5077 22.0471L36.9966 16.558C38.0502 15.5131 37.9935 13.7324 36.9051 12.742C35.863 11.7937 34.2497 11.8475 33.2327 12.8644L29.2289 16.8681L28.7321 16.3712C27.7205 15.3495 26.0175 15.3566 25.003 16.3711C23.9751 17.3991 23.975 19.0718 25.003 20.0999L26.9505 22.0475ZM26.2462 17.6141C26.5844 17.2759 27.1525 17.2741 27.4892 17.614L28.3588 18.4838C28.8282 18.958 29.6282 18.9599 30.0991 18.484L34.4757 14.1074C34.822 13.761 35.3813 13.7317 35.7222 14.0419C36.0877 14.3745 36.1061 14.9665 35.7538 15.3149L30.2649 20.804C29.9889 21.0798 29.6211 21.2318 29.2291 21.2318C28.8371 21.2318 28.4692 21.08 28.1935 20.8043L26.2463 18.857C25.9035 18.5144 25.9035 17.9568 26.2462 17.6141ZM41.12 38.0312H20.88C20.3946 38.0312 20.0011 38.4246 20.0011 38.9102C20.0011 39.3957 20.3946 39.7891 20.88 39.7891H41.12C41.6053 39.7891 41.9989 39.3957 41.9989 38.9102C41.9989 38.4246 41.6053 38.0312 41.12 38.0312Z"
      fill="#DA052C"
      stroke="#DA052C"
      strokeWidth="0.3"
    />
  </svg>
);

export const CRM_SYSTEM_SVG = (
  <svg
    width="60"
    height="60"
    viewBox="0 0 60 60"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M30.9677 7.74194C32.0352 7.74194 32.9032 8.61 32.9032 9.67742H34.8387C34.8387 7.54258 33.1026 5.80645 30.9677 5.80645C28.8329 5.80645 27.0968 7.54258 27.0968 9.67742V11.6129C27.0968 13.7477 28.8329 15.4839 30.9677 15.4839C33.1026 15.4839 34.8387 13.7477 34.8387 11.6129H32.9032C32.9032 12.6803 32.0352 13.5484 30.9677 13.5484C29.9003 13.5484 29.0323 12.6803 29.0323 11.6129V9.67742C29.0323 8.61 29.9003 7.74194 30.9677 7.74194Z"
      fill="#DA052C"
    />
    <path
      d="M41.6129 5.80645H36.7742V15.4839H38.7097V11.6129H41.6129C42.1461 11.6129 42.5806 12.0474 42.5806 12.5806V15.4839H44.5161V12.5806C44.5161 11.8345 44.2248 11.16 43.7613 10.6452C44.2258 10.1303 44.5161 9.45581 44.5161 8.70968C44.5161 7.10903 43.2135 5.80645 41.6129 5.80645ZM38.7097 9.67742V7.74194H41.6129C42.1461 7.74194 42.5806 8.17645 42.5806 8.70968C42.5806 9.2429 42.1461 9.67742 41.6129 9.67742H38.7097Z"
      fill="#DA052C"
    />
    <path
      d="M51.5603 11.6129H51.0203L49.0848 5.80645H46.4516V15.4839H48.3871V9.83419L49.6248 13.5484H52.9558L54.1935 9.83419V15.4839H56.129V5.80645H53.4958L51.5603 11.6129Z"
      fill="#DA052C"
    />
    <path
      d="M3.87097 19.3548H5.80645V21.2903H3.87097V19.3548Z"
      fill="#DA052C"
    />
    <path
      d="M7.74194 19.3548H9.67742V21.2903H7.74194V19.3548Z"
      fill="#DA052C"
    />
    <path
      d="M11.6129 19.3548H13.5484V21.2903H11.6129V19.3548Z"
      fill="#DA052C"
    />
    <path
      d="M49.3548 29.0323H33.871C32.2703 29.0323 30.9677 30.3348 30.9677 31.9355V33.871C30.9677 35.4716 32.2703 36.7742 33.871 36.7742V38.7097C32.2703 38.7097 30.9677 40.0123 30.9677 41.6129V43.5484C30.9677 45.149 32.2703 46.4516 33.871 46.4516V48.3871C32.2703 48.3871 30.9677 49.6897 30.9677 51.2903V53.2258C30.9677 54.8265 32.2703 56.129 33.871 56.129H49.3548C50.9555 56.129 52.2581 54.8265 52.2581 53.2258V51.2903C52.2581 49.6897 50.9555 48.3871 49.3548 48.3871V46.4516C50.9555 46.4516 52.2581 45.149 52.2581 43.5484V41.6129C52.2581 40.0123 50.9555 38.7097 49.3548 38.7097V36.7742C50.9555 36.7742 52.2581 35.4716 52.2581 33.871V31.9355C52.2581 30.3348 50.9555 29.0323 49.3548 29.0323ZM50.3226 51.2903V53.2258C50.3226 53.76 49.8881 54.1935 49.3548 54.1935H33.871C33.3377 54.1935 32.9032 53.76 32.9032 53.2258V51.2903C32.9032 50.7561 33.3377 50.3226 33.871 50.3226H49.3548C49.8881 50.3226 50.3226 50.7561 50.3226 51.2903ZM47.4194 48.3871H35.8064V46.4516H47.4194V48.3871ZM50.3226 41.6129V43.5484C50.3226 44.0826 49.8881 44.5161 49.3548 44.5161H33.871C33.3377 44.5161 32.9032 44.0826 32.9032 43.5484V41.6129C32.9032 41.0787 33.3377 40.6452 33.871 40.6452H49.3548C49.8881 40.6452 50.3226 41.0787 50.3226 41.6129ZM47.4194 38.7097H35.8064V36.7742H47.4194V38.7097ZM50.3226 33.871C50.3226 34.4052 49.8881 34.8387 49.3548 34.8387H33.871C33.3377 34.8387 32.9032 34.4052 32.9032 33.871V31.9355C32.9032 31.4013 33.3377 30.9677 33.871 30.9677H49.3548C49.8881 30.9677 50.3226 31.4013 50.3226 31.9355V33.871Z"
      fill="#DA052C"
    />
    <path
      d="M55.1613 0H28.0645C25.3965 0 23.2258 2.17065 23.2258 4.83871V15.4839H2.90323C1.30258 15.4839 0 16.7865 0 18.3871V57.0968C0 58.6974 1.30258 60 2.90323 60H53.2258C54.8265 60 56.129 58.6974 56.129 57.0968V21.1926C58.3345 20.7426 60 18.7887 60 16.4516V4.83871C60 2.17065 57.8294 0 55.1613 0ZM2.90323 17.4194H23.3235C23.7735 19.6248 25.7274 21.2903 28.0645 21.2903H31.4826L33.0958 23.2258H1.93548V18.3871C1.93548 17.8539 2.37 17.4194 2.90323 17.4194ZM53.2258 58.0645H2.90323C2.37 58.0645 1.93548 57.631 1.93548 57.0968V25.1613H34.7081L35.4377 26.0371C35.999 26.7106 36.8235 27.0968 37.7003 27.0968C38.9681 27.0968 40.0413 26.2868 40.4555 25.1613H54.1935V57.0968C54.1935 57.631 53.759 58.0645 53.2258 58.0645ZM40.6452 23.2258V21.2903H54.1935V23.2258H40.6452ZM58.0645 16.4516C58.0645 18.0523 56.7619 19.3548 55.1613 19.3548H38.7097V24.1519C38.7097 24.7084 38.2568 25.1613 37.7003 25.1613C37.3994 25.1613 37.1168 25.0287 36.9242 24.7984L32.3884 19.3548H28.0645C26.4639 19.3548 25.1613 18.0523 25.1613 16.4516V4.83871C25.1613 3.23806 26.4639 1.93548 28.0645 1.93548H55.1613C56.7619 1.93548 58.0645 3.23806 58.0645 4.83871V16.4516Z"
      fill="#DA052C"
    />
    <path
      d="M16.4516 48.3871C22.321 48.3871 27.0968 43.6113 27.0968 37.7419C27.0968 31.8726 22.321 27.0968 16.4516 27.0968C10.5823 27.0968 5.80645 31.8726 5.80645 37.7419C5.80645 43.6113 10.5823 48.3871 16.4516 48.3871ZM16.4516 46.4516C14.3981 46.4516 12.5119 45.7335 11.0216 44.5403L16.8523 38.7097H25.1042C24.6213 43.0577 20.9265 46.4516 16.4516 46.4516ZM23.25 32.3119C24.2526 33.5652 24.9174 35.0971 25.1042 36.7742H18.7877L23.25 32.3119ZM21.8816 30.9435L16.4516 36.3735L11.0216 30.9435C12.5119 29.7503 14.3981 29.0323 16.4516 29.0323C18.5052 29.0323 20.3913 29.7503 21.8816 30.9435ZM9.65323 32.3119L15.0832 37.7419L9.65323 43.1719C8.46 41.6816 7.74194 39.7955 7.74194 37.7419C7.74194 35.6884 8.46 33.8023 9.65323 32.3119Z"
      fill="#DA052C"
    />
    <path
      d="M3.87097 50.3226H5.80645V52.2581H3.87097V50.3226Z"
      fill="#DA052C"
    />
    <path
      d="M7.74194 50.3226H29.0323V52.2581H7.74194V50.3226Z"
      fill="#DA052C"
    />
    <path d="M3.87097 54.1935H9.67742V56.129H3.87097V54.1935Z" fill="#DA052C" />
    <path d="M11.6129 54.1935H29.0323V56.129H11.6129V54.1935Z" fill="#DA052C" />
  </svg>
);

export const CLIENTS_ACCOUNT_SVG = (
  <svg
    width="60"
    height="54"
    viewBox="0 0 60 54"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.1213 5.65993L16.4053 11.4644L14.2049 13.6559L8.37663 14.3698C8.00722 14.4159 7.69136 14.6557 7.549 14.9985L5.48036 19.9682C5.33662 20.312 5.39064 20.7054 5.62089 20.9986L9.2354 25.6068V28.6977L5.62089 33.31C5.39064 33.6032 5.33708 33.9971 5.48036 34.3404L7.549 39.3105C7.69136 39.6529 8.00722 39.8927 8.37663 39.9388L14.2049 40.6527L16.4053 42.8401L17.1231 48.6446C17.1694 49.012 17.4097 49.327 17.7535 49.4688L22.7435 51.5295C23.0887 51.6722 23.4837 51.6184 23.7781 51.3891L28.4052 47.7898H31.5088L36.1373 51.3891C36.4311 51.6184 36.8266 51.6722 37.1718 51.5295L42.1619 49.4688C42.5052 49.327 42.746 49.012 42.7918 48.6446L43.51 42.8401L45.7091 40.6486L51.5373 39.9347C51.9068 39.8886 52.2226 39.6488 52.365 39.3064L54.4341 34.3363C54.5773 33.993 54.5233 33.5991 54.2935 33.3059L50.679 28.6977V25.6068L54.2935 20.9963C54.5233 20.7036 54.5773 20.3097 54.4341 19.9664L52.365 14.9962C52.2226 14.6539 51.9068 14.4136 51.5373 14.368L45.7091 13.6559L43.5086 11.4644L42.7908 5.65993C42.7451 5.29248 42.5043 4.97791 42.161 4.83567L37.1704 2.77548C36.8257 2.63278 36.4302 2.68612 36.1359 2.91544L33.0469 5.3171C31.1339 4.20973 28.7718 4.20973 26.8588 5.3171L23.774 2.91544C23.4805 2.6843 23.0841 2.63096 22.7394 2.77548L17.7493 4.83567C17.4065 4.97837 17.1666 5.29294 17.1213 5.65993ZM34.0947 10.668V16.6065C34.0988 17.629 33.5184 18.565 32.5978 19.0181C32.2472 19.1928 32.0256 19.5502 32.0261 19.9404V22.0011C32.0261 22.4738 32.3493 22.886 32.8102 23.0004L37.9514 24.281C39.3329 24.6252 40.3015 25.8612 40.302 27.279V37.2271C34.7397 42.9171 25.5995 43.0393 19.8862 37.5002C19.7937 37.4104 19.7022 37.3196 19.612 37.2271V27.279C19.6124 25.8612 20.5811 24.6252 21.9626 24.281L27.1037 23.0004C27.5647 22.886 27.8879 22.4738 27.8879 22.0011V19.9404C27.8884 19.5502 27.6668 19.1928 27.3157 19.0181C26.3956 18.565 25.8147 17.629 25.8188 16.6065V10.668C25.8188 8.39212 27.6718 6.54711 29.957 6.54711C32.2421 6.54711 34.0947 8.39212 34.0947 10.668ZM36.1638 16.6065V14.1268C43.3736 17.5141 46.4612 26.0809 43.06 33.2613C42.8522 33.6998 42.6219 34.1279 42.3706 34.5432V27.279C42.3729 24.9143 40.7565 22.8522 38.4522 22.281L34.0947 21.1964V20.5267C35.3943 19.6423 36.1693 18.1738 36.1638 16.6065ZM25.8188 20.5267V21.1964L21.4618 22.281C19.1574 22.8522 17.5411 24.9143 17.5434 27.279V34.5432C13.4308 27.7422 15.6336 18.9083 22.4625 14.813C22.88 14.5627 23.3093 14.3338 23.7502 14.1268V16.6065C23.7447 18.1738 24.5197 19.6423 25.8188 20.5267ZM18.4131 12.068L19.1002 6.50471L22.9761 4.90679L25.2356 6.66336C24.2761 7.77894 23.7493 9.19951 23.7502 10.668V11.8797C15.276 15.2935 11.185 24.9029 14.6132 33.3424C18.0409 41.782 27.6897 45.8563 36.1638 42.4421C44.6379 39.0283 48.729 29.419 45.3008 20.9794C43.6189 16.8385 40.3217 13.5547 36.1638 11.8797V10.668C36.1643 9.19997 35.6374 7.78031 34.6784 6.66564L36.9379 4.91409L40.8193 6.50699L41.5059 12.0703C41.5338 12.2982 41.6377 12.5107 41.8007 12.673L44.5029 15.3641C44.6658 15.5264 44.8792 15.6299 45.108 15.6577L50.6941 16.342L52.2995 20.2021L48.8374 24.6179C48.6946 24.7985 48.6177 25.0218 48.6182 25.2516V29.0574C48.6177 29.2872 48.6946 29.5101 48.8374 29.6911L52.2995 34.1065L50.6859 37.9702L45.0998 38.6541C44.8709 38.6823 44.6576 38.7854 44.4946 38.9477L41.7925 41.6388C41.6295 41.8016 41.5256 42.0136 41.4977 42.2415L40.8106 47.8048L36.9379 49.3959L32.504 45.9475C32.3223 45.8062 32.0984 45.7291 31.8677 45.7291H28.0463C27.8156 45.7291 27.5917 45.8062 27.41 45.9475L22.9761 49.3959L19.1002 47.798L18.4131 42.2342C18.3852 42.0063 18.2813 41.7943 18.1183 41.6315L15.4161 38.9408C15.2532 38.7781 15.0403 38.675 14.811 38.6468L9.22487 37.9629L7.62269 34.1047L11.0848 29.6889C11.2276 29.5083 11.3045 29.2849 11.304 29.0552V25.2493C11.3045 25.0196 11.2276 24.7966 11.0848 24.6156L7.62269 20.2003L9.22807 16.3398L14.8142 15.6555C15.043 15.6276 15.2564 15.5242 15.4193 15.3619L18.1215 12.6712C18.2836 12.508 18.3861 12.296 18.4131 12.068Z"
      fill="#DA052C"
    />
    <path
      d="M0.170746 23.8001L2.22702 24.0184C3.29819 14.41 9.27338 6.03288 18.0299 1.86142L17.1423 0C7.73712 4.481 1.32019 13.4795 0.170746 23.8001Z"
      fill="#DA052C"
    />
    <path
      d="M0 27C0 27.3574 0.00640869 27.7121 0.0196839 28.0663L2.08878 27.9943C2.0755 27.6647 2.06909 27.3333 2.06909 27C2.06909 26.6667 2.07504 26.3358 2.08649 26.0057L0.0173951 25.9337C0.00640869 26.2879 0 26.6426 0 27Z"
      fill="#DA052C"
    />
    <path
      d="M41.9701 52.1386L42.8577 54C52.2629 49.519 58.6794 40.521 59.8293 30.2013L57.773 29.9825C56.7014 39.5905 50.7266 47.9671 41.9701 52.1386Z"
      fill="#DA052C"
    />
    <path
      d="M59.9803 28.0663C59.9936 27.7121 60 27.3574 60 27C60 26.6426 59.9936 26.2883 59.9803 25.9337L57.9112 26.0057C57.9245 26.3358 57.9309 26.6667 57.9309 27C57.9309 27.3333 57.925 27.6647 57.9135 27.9943L59.9803 28.0663Z"
      fill="#DA052C"
    />
    <path
      d="M24.8277 25.9697H26.8964V28.0303H24.8277V25.9697Z"
      fill="#DA052C"
    />
    <path d="M22.7586 30.091H37.2414V32.1512H22.7586V30.091Z" fill="#DA052C" />
    <path
      d="M22.7586 34.2118H35.1723V36.2725H22.7586V34.2118Z"
      fill="#DA052C"
    />
    <path
      d="M28.9655 25.9697H37.2414V28.0303H28.9655V25.9697Z"
      fill="#DA052C"
    />
  </svg>
);

export const TELEGRAM_BOT_SVG = (
  <svg
    width="60"
    height="60"
    viewBox="0 0 60 60"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M29.9954 43.2024C29.5097 43.2024 29.1119 43.6006 29.1119 44.0863C29.1119 44.5715 29.5097 44.9698 29.9954 44.9698C30.4807 44.9698 30.8789 44.5715 30.8789 44.0863C30.8789 43.6006 30.4807 43.2024 29.9954 43.2024Z"
      fill="#DA052C"
    />
    <path
      d="M26.7169 40.8032C26.3736 41.1461 26.3736 41.7027 26.7169 42.0461C27.0602 42.3894 27.6164 42.3894 27.9597 42.0461C29.0822 40.9236 30.9082 40.9236 32.0306 42.0461C32.2023 42.2177 32.4275 42.3033 32.6523 42.3033C32.877 42.3033 33.1023 42.2177 33.2735 42.0461C33.6168 41.7027 33.6168 41.1461 33.2735 40.8032C31.4662 38.9955 28.5246 38.9955 26.7169 40.8032Z"
      fill="#DA052C"
    />
    <path
      d="M25.3029 39.3887C27.8902 36.8015 32.1002 36.8015 34.688 39.3887C34.8596 39.5604 35.0844 39.6465 35.3091 39.6465C35.5344 39.6465 35.7591 39.5609 35.9308 39.3887C36.2741 39.0459 36.2741 38.4892 35.9308 38.1459C32.6578 34.8734 27.3326 34.8734 24.0596 38.1459C23.7167 38.4892 23.7167 39.0459 24.0596 39.3887C24.4029 39.7321 24.9596 39.7321 25.3029 39.3887Z"
      fill="#DA052C"
    />
    <path
      d="M56.3031 9.39377H51.606C51.1208 9.39377 50.7271 9.78745 50.7271 10.2727C50.7271 10.7584 51.1208 11.1516 51.606 11.1516H56.3031C57.3724 11.1516 58.2422 12.0218 58.2422 13.0911V46.9693H56.3031C55.8179 46.9693 55.4242 47.363 55.4242 47.8482C55.4242 48.3339 55.8179 48.7271 56.3031 48.7271H58.2422V48.7875C58.2422 49.8569 57.3724 50.7271 56.3031 50.7271H3.6969C2.62756 50.7271 1.75781 49.8569 1.75781 48.7875V48.7271H52.5453C53.0305 48.7271 53.4242 48.3339 53.4242 47.8482C53.4242 47.363 53.0305 46.9693 52.5453 46.9693H45.9091V40.3331C45.9091 35.1869 41.722 30.9998 36.5758 30.9998H35.5756V29.0002H38.4544C45.1547 29.0002 50.6062 23.5487 50.6062 16.8484C50.6062 10.4439 45.6248 5.18097 39.3333 4.72916V0.878906C39.3333 0.393677 38.9397 0 38.4544 0C37.9692 0 37.5755 0.393677 37.5755 0.878906V4.69711H22.4245V0.878906C22.4245 0.393677 22.0308 0 21.5456 0C21.0603 0 20.6667 0.393677 20.6667 0.878906V4.72916C14.3747 5.18097 9.39377 10.4439 9.39377 16.8484C9.39377 23.5487 14.8453 29.0002 21.5456 29.0002H24.424V30.9998H23.4242C18.2776 30.9998 14.0909 35.1869 14.0909 40.3331V46.9693H1.75781V13.0911C1.75781 12.0218 2.62756 11.1516 3.6969 11.1516H8.39401C8.87924 11.1516 9.27292 10.7584 9.27292 10.2727C9.27292 9.78745 8.87924 9.39377 8.39401 9.39377H3.6969C1.65848 9.39377 0 11.0522 0 13.0911V48.7875C0 50.8264 1.65848 52.4849 3.6969 52.4849H20.4199L18.9807 58.2422H17.7878C17.3026 58.2422 16.9089 58.6354 16.9089 59.1211C16.9089 59.6068 17.3026 60 17.7878 60H42.2122C42.6974 60 43.0911 59.6068 43.0911 59.1211C43.0911 58.6354 42.6974 58.2422 42.2122 58.2422H41.0193L39.5801 52.4849H56.3026C58.3415 52.4849 60 50.8264 60 48.788V13.0911C60 11.0522 58.3415 9.39377 56.3031 9.39377ZM44.1513 40.3331V46.9693H40.2727V33.7248C42.5848 35.023 44.1513 37.4982 44.1513 40.3331ZM11.1516 16.8484C11.1516 11.1172 15.8144 6.45493 21.5456 6.45493H38.4544C44.1856 6.45493 48.8484 11.1172 48.8484 16.8484C48.8484 22.5797 44.1856 27.2424 38.4544 27.2424H21.5456C15.8144 27.2424 11.1516 22.5797 11.1516 16.8484ZM26.1818 29.0002H33.8177V30.9998H26.1818V29.0002ZM36.5758 32.7576C37.2459 32.7576 37.896 32.8459 38.5149 33.0103V46.9693H21.4851V33.0103C22.1045 32.8459 22.7541 32.7576 23.4242 32.7576H36.5758ZM15.8487 40.3331C15.8487 37.4982 17.4152 35.023 19.7273 33.7244V46.9693H15.8487V40.3331ZM39.2075 58.2422H20.7925L22.2318 52.4849H37.7682L39.2075 58.2422Z"
      fill="#DA052C"
    />
    <path
      d="M23.4242 15.0302C22.939 15.0302 22.5453 15.4239 22.5453 15.9091V17.7878C22.5453 18.2735 22.939 18.6667 23.4242 18.6667C23.9095 18.6667 24.3031 18.2735 24.3031 17.7878V15.9091C24.3031 15.4239 23.9095 15.0302 23.4242 15.0302Z"
      fill="#DA052C"
    />
    <path
      d="M37.4547 17.7878V15.9091C37.4547 15.4239 37.061 15.0302 36.5758 15.0302C36.0905 15.0302 35.6969 15.4239 35.6969 15.9091V17.7878C35.6969 18.2735 36.0905 18.6667 36.5758 18.6667C37.061 18.6667 37.4547 18.2735 37.4547 17.7878Z"
      fill="#DA052C"
    />
    <path
      d="M30 25.2425C31.9116 25.2425 33.5564 24.0797 34.2645 22.4245H36.5758C39.6501 22.4245 42.1513 19.9228 42.1513 16.8484C42.1513 13.7737 39.6501 11.2724 36.5758 11.2724H27.1815C26.6959 11.2724 26.3026 11.6661 26.3026 12.1513C26.3026 12.637 26.6959 13.0302 27.1815 13.0302H36.5758C38.681 13.0302 40.3935 14.7432 40.3935 16.8484C40.3935 18.9537 38.681 20.6667 36.5758 20.6667H34.6349C34.6349 20.6461 34.6362 20.6264 34.6362 20.6062C34.6362 20.1205 34.2426 19.7273 33.7573 19.7273H26.2422C25.757 19.7273 25.3633 20.1205 25.3633 20.6062C25.3633 20.6264 25.3647 20.6465 25.3647 20.6667H23.4242C21.319 20.6667 19.606 18.9537 19.606 16.8484C19.606 14.7432 21.319 13.0302 23.4242 13.0302C23.9095 13.0302 24.3031 12.637 24.3031 12.1513C24.3031 11.6661 23.9095 11.2724 23.4242 11.2724C20.3494 11.2724 17.8482 13.7737 17.8482 16.8484C17.8482 19.9228 20.3494 22.4245 23.4242 22.4245H25.735C26.4436 24.0797 28.0884 25.2425 30 25.2425ZM32.7415 21.4851C32.3694 22.6437 31.2808 23.4846 30 23.4846C28.7192 23.4846 27.6306 22.6437 27.2585 21.4851H32.7415Z"
      fill="#DA052C"
    />
  </svg>
);

export const MOBILE_APP_SVG = (
  <svg
    width="60"
    height="60"
    viewBox="0 0 60 60"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M26.9128 16.6003L25.5872 15.2747L22.7747 18.0872C22.4081 18.4537 22.4081 19.0463 22.7747 19.4128L25.5872 22.2253L26.9128 20.8997L24.7631 18.75L26.9128 16.6003Z"
      fill="#DA052C"
    />
    <path
      d="M37.2253 18.0872L34.4128 15.2747L33.0872 16.6003L35.2369 18.75L33.0872 20.8997L34.4128 22.2253L37.2253 19.4128C37.5919 19.0463 37.5919 18.4537 37.2253 18.0872Z"
      fill="#DA052C"
    />
    <path
      d="M30.0481 15.6438L28.172 21.2685L29.9506 21.8618L31.8267 16.237L30.0481 15.6438Z"
      fill="#DA052C"
    />
    <path
      d="M43.125 0H16.875C15.8409 0 15 0.840937 15 1.875V58.125C15 59.1591 15.8409 60 16.875 60H43.125C44.1591 60 45 59.1591 45 58.125V1.875C45 0.840937 44.1591 0 43.125 0ZM43.125 58.125H16.875V1.875L43.125 1.87406V58.125Z"
      fill="#DA052C"
    />
    <path
      d="M23.4375 9.375V7.5H19.6875C19.17 7.5 18.75 7.91906 18.75 8.4375V45.9375C18.75 46.4559 19.17 46.875 19.6875 46.875H23.4375V45H20.625V9.375H23.4375Z"
      fill="#DA052C"
    />
    <path
      d="M40.3125 7.5H36.5625V9.375H39.375V45H36.5625V46.875H40.3125C40.83 46.875 41.25 46.4559 41.25 45.9375V8.4375C41.25 7.91906 40.83 7.5 40.3125 7.5Z"
      fill="#DA052C"
    />
    <path d="M34.6875 7.5H25.3125V9.375H34.6875V7.5Z" fill="#DA052C" />
    <path
      d="M30 48.75C27.9319 48.75 26.25 50.4319 26.25 52.5C26.25 54.5681 27.9319 56.25 30 56.25C32.0681 56.25 33.75 54.5681 33.75 52.5C33.75 50.4319 32.0681 48.75 30 48.75ZM30 54.375C28.9659 54.375 28.125 53.5341 28.125 52.5C28.125 51.4659 28.9659 50.625 30 50.625C31.0341 50.625 31.875 51.4659 31.875 52.5C31.875 53.5341 31.0341 54.375 30 54.375Z"
      fill="#DA052C"
    />
    <path d="M33.75 3.75H26.25V5.625H33.75V3.75Z" fill="#DA052C" />
    <path d="M34.6875 45H25.3125V46.875H34.6875V45Z" fill="#DA052C" />
    <path
      d="M13.125 7.5V5.625H0.9375C0.42 5.625 0 6.04406 0 6.5625V53.4375C0 53.9559 0.42 54.375 0.9375 54.375H13.125V52.5H1.875V15H13.125V13.125H1.875V7.5H13.125Z"
      fill="#DA052C"
    />
    <path d="M5.625 9.375H3.75V11.25H5.625V9.375Z" fill="#DA052C" />
    <path d="M9.375 9.375H7.5V11.25H9.375V9.375Z" fill="#DA052C" />
    <path d="M13.125 9.375H11.25V11.25H13.125V9.375Z" fill="#DA052C" />
    <path
      d="M59.0625 5.625H46.875V7.5H58.125V13.125H46.875V15H58.125V52.5H46.875V54.375H59.0625C59.58 54.375 60 53.9559 60 53.4375V6.5625C60 6.04406 59.58 5.625 59.0625 5.625Z"
      fill="#DA052C"
    />
    <path d="M56.25 9.375H50.625V11.25H56.25V9.375Z" fill="#DA052C" />
    <path d="M27.1875 26.25H23.4375V28.125H27.1875V26.25Z" fill="#DA052C" />
    <path d="M36.5625 26.25H29.0625V28.125H36.5625V26.25Z" fill="#DA052C" />
    <path d="M36.5625 30H32.8125V31.875H36.5625V30Z" fill="#DA052C" />
    <path d="M30.9375 30H23.4375V31.875H30.9375V30Z" fill="#DA052C" />
    <path d="M27.1875 33.75H23.4375V35.625H27.1875V33.75Z" fill="#DA052C" />
    <path d="M36.5625 33.75H29.0625V35.625H36.5625V33.75Z" fill="#DA052C" />
    <path d="M36.5625 37.5H32.8125V39.375H36.5625V37.5Z" fill="#DA052C" />
    <path d="M30.9375 37.5H23.4375V39.375H30.9375V37.5Z" fill="#DA052C" />
  </svg>
);

export const INTEGRATION_WEBSITE_SVG = (
  <svg
    width="60"
    height="60"
    viewBox="0 0 60 60"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M42.4301 27.0968C38.7078 27.0968 35.6798 30.1355 35.6798 33.871C35.6798 37.6064 38.7078 40.6452 42.4301 40.6452C46.1524 40.6452 49.1803 37.6064 49.1803 33.871C49.1803 30.1355 46.1524 27.0968 42.4301 27.0968ZM42.4301 38.7097C39.7715 38.7097 37.6085 36.539 37.6085 33.871C37.6085 31.2029 39.7715 29.0323 42.4301 29.0323C45.0887 29.0323 47.2517 31.2029 47.2517 33.871C47.2517 36.539 45.0887 38.7097 42.4301 38.7097ZM42.4301 30.9677C40.8351 30.9677 39.5371 32.2703 39.5371 33.871C39.5371 35.4716 40.8351 36.7742 42.4301 36.7742C44.0251 36.7742 45.323 35.4716 45.323 33.871C45.323 32.2703 44.0251 30.9677 42.4301 30.9677ZM42.4301 34.8387C41.8987 34.8387 41.4658 34.4042 41.4658 33.871C41.4658 33.3377 41.8987 32.9032 42.4301 32.9032C42.9614 32.9032 43.3944 33.3377 43.3944 33.871C43.3944 34.4042 42.9614 34.8387 42.4301 34.8387ZM52.9267 37.1961C52.9923 36.4752 53.0376 35.7513 53.0376 35.0226C53.0376 34.9606 53.0318 34.9006 53.0309 34.8387H53.0376V2.90323C53.0376 1.30258 51.7396 0 50.1446 0H2.89296C1.29797 0 0 1.30258 0 2.90323V43.5484C0 45.149 1.29797 46.4516 2.89296 46.4516H25.2459L24.8602 48.3871H35.8689L36.5313 49.4516L36.1572 50.3913C35.1871 52.8242 35.9682 55.621 38.0569 57.1926L39.8824 58.5668L41.729 54.8613C42.8042 55.9897 43.3944 57.4655 43.3944 59.0323V60H45.7859L47.3905 57.9871C49.1755 55.7477 49.6249 52.7032 48.5641 50.041L48.3288 49.4506L48.9913 48.3861H60L58.7377 42.0552L52.9267 37.1961ZM2.89296 1.93548H50.1446C50.676 1.93548 51.109 2.37 51.109 2.90323V11.6129H1.92864V2.90323C1.92864 2.37 2.36162 1.93548 2.89296 1.93548ZM25.6316 44.5161H2.89296C2.36162 44.5161 1.92864 44.0816 1.92864 43.5484V13.5484H51.109V25.6248C50.5352 24.2777 49.8505 22.9732 49.0299 21.7374L46.2314 17.5239C45.3819 16.2474 43.9614 15.4839 42.4301 15.4839C40.8987 15.4839 39.4783 16.2474 38.6297 17.5248L35.8312 21.7384C33.2083 25.6858 31.8226 30.2787 31.8226 35.0226C31.8226 35.7513 31.8679 36.4752 31.9335 37.1961L26.1225 42.0552L25.6316 44.5161ZM46.7175 48.3871H38.1427L37.0849 46.6887C36.6471 45.9861 36.2633 45.2584 35.9094 44.5161H48.9499C48.596 45.2574 48.2122 45.9861 47.7743 46.6887L46.7175 48.3871ZM49.7753 42.5806H35.0849C34.2064 40.171 33.7512 37.6161 33.7512 35.0226C33.7512 31.5716 34.5612 28.2126 36.0887 25.1613H48.7715C50.2989 28.2126 51.109 31.5716 51.109 35.0226C51.109 37.6161 50.6538 40.171 49.7753 42.5806ZM37.1813 23.2258C37.2681 23.0894 37.3452 22.9471 37.4349 22.8116L40.2334 18.5981C40.7242 17.8606 41.5458 17.4194 42.4301 17.4194C43.3144 17.4194 44.136 17.8606 44.6258 18.599L47.4243 22.8126C47.514 22.9481 47.5911 23.0894 47.6779 23.2268H37.1813V23.2258ZM27.8795 43.1052L32.2469 39.4529C32.7049 41.8955 33.5342 44.2558 34.7232 46.4516H27.2131L27.8795 43.1052ZM45.8852 56.7784L45.2025 57.6339C44.9229 56.0352 44.163 54.5632 42.9952 53.3913L41.2025 51.5923L39.1929 55.6268C37.8177 54.5758 37.3057 52.7226 37.9489 51.1094L38.2613 50.3226H46.5988L46.7734 50.761C47.5767 52.7768 47.2363 55.0819 45.8852 56.7784ZM50.1369 46.4516C51.3259 44.2558 52.1553 41.8955 52.6133 39.4529L56.9807 43.1052L57.6471 46.4516H50.1369ZM9.6432 3.87097H3.85728V9.67742H9.6432V3.87097ZM7.71456 7.74194H5.78592V5.80645H7.71456V7.74194ZM17.3578 3.87097H11.5718V9.67742H17.3578V3.87097ZM15.4291 7.74194H13.5005V5.80645H15.4291V7.74194ZM25.0723 3.87097H19.2864V9.67742H25.0723V3.87097ZM23.1437 7.74194H21.215V5.80645H23.1437V7.74194ZM27.001 15.4839H21.215V34.8387H19.2864V23.2258H13.5005V34.8387H11.5718V27.0968H5.78592V34.8387H3.85728V36.7742H28.9296V34.8387H27.001V15.4839ZM23.1437 17.4194H25.0723V34.8387H23.1437V17.4194ZM15.4291 25.1613H17.3578V34.8387H15.4291V25.1613ZM7.71456 29.0323H9.6432V34.8387H7.71456V29.0323ZM5.78592 17.4194H3.85728V15.4839H5.78592V17.4194ZM17.3578 17.4194H7.71456V15.4839H17.3578V17.4194ZM5.78592 21.2903H3.85728V19.3548H5.78592V21.2903ZM17.3578 21.2903H7.71456V19.3548H17.3578V21.2903Z"
      fill="#DA052C"
    />
  </svg>
);

export const CHECK_MARK_SVG = (
  <svg
    width="14"
    height="10"
    viewBox="0 0 14 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 3.50395C0 3.50395 3.00767 5.5012 4.86957 9.98625C4.97698 10.2666 5.83632 6.23703 14 0C14 0 7.87724 1.75197 4.83376 5.81655C4.83376 5.81655 2.93606 4.13466 0 3.50395Z"
      fill="#DA052C"
    />
  </svg>
);

export const YOUTUBE_ICON_SVG = (
  <svg
    width="18"
    height="13"
    viewBox="0 0 18 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18 4.98989C18 4.59595 17.9343 4.13636 17.9343 3.61111C17.8686 3.08586 17.8029 2.5606 17.7372 2.10101C17.6058 1.57576 17.4088 1.18182 17.0146 0.853537C16.6861 0.525254 16.2263 0.328279 15.7664 0.262622C14.2555 0.0656525 12.0219 0 9.00001 0C5.97811 0 3.67883 0.0656525 2.23357 0.262622C1.77372 0.328279 1.31387 0.525254 0.985402 0.853537C0.656934 1.18182 0.394157 1.57576 0.26277 2.10101C0.131383 2.5606 0.0656975 3.0202 0.0656975 3.61111C4.00863e-06 4.13636 0 4.59595 0 4.98989C0 5.38383 0 5.84343 0 6.49999C0 7.15656 0 7.68181 0 8.0101C0 8.40404 0.0656975 8.86364 0.0656975 9.38889C0.131391 9.91414 0.197076 10.4394 0.26277 10.899C0.394157 11.4242 0.591241 11.8182 0.985402 12.1465C1.31387 12.4747 1.77372 12.6717 2.23357 12.7374C3.74452 12.9343 5.97811 13 9.00001 13C12.0219 13 14.3212 12.9343 15.7664 12.7374C16.2263 12.6717 16.6861 12.4747 17.0146 12.1465C17.3431 11.8182 17.6058 11.4242 17.7372 10.899C17.8686 10.4394 17.9343 9.9798 17.9343 9.38889C18 8.86364 18 8.40404 18 8.0101C18 7.61616 18 7.15656 18 6.49999C18 5.84343 18 5.31817 18 4.98989ZM12.4818 7.02525L7.29198 10.2424C7.22628 10.3081 7.0949 10.3737 6.96351 10.3737C6.83212 10.3737 6.76643 10.3737 6.63504 10.3081C6.43796 10.1768 6.30657 9.9798 6.30657 9.71717V3.21717C6.30657 2.95454 6.43796 2.75758 6.63504 2.62626C6.83212 2.49495 7.0949 2.49495 7.29198 2.62626L12.4818 5.84343C12.6788 5.97474 12.8102 6.17171 12.8102 6.36868C12.8102 6.56565 12.6788 6.89394 12.4818 7.02525Z"
      fill="#F40000"
    />
  </svg>
);

export const TELEGRAM_ICON_SVG = (
  <svg
    width="20"
    height="17"
    viewBox="0 0 20 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.350701 8.15986L4.9488 9.83055L6.74126 15.4501C6.8192 15.8298 7.2868 15.9057 7.59854 15.6779L10.1703 13.6275C10.4041 13.3997 10.7938 13.3997 11.1055 13.6275L15.7036 16.893C16.0154 17.1208 16.483 16.9689 16.5609 16.5892L19.99 0.641807C20.0679 0.262107 19.6782 -0.11759 19.2886 0.0342903L0.350701 7.17265C-0.1169 7.32453 -0.1169 8.00798 0.350701 8.15986ZM6.50747 8.9952L15.5477 3.60347C15.7036 3.52753 15.8595 3.75535 15.7036 3.83129L8.29993 10.5899C8.06613 10.8178 7.83233 11.1215 7.83233 11.5012L7.59854 13.3238C7.59854 13.5516 7.20886 13.6275 7.13093 13.3238L6.19572 9.98242C5.96192 9.60273 6.1178 9.14708 6.50747 8.9952Z"
      fill="#2F89CE"
    />
  </svg>
);

export const FACEBOOK_ICON_SVG = (
  <svg
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17 2.81865C17 1.32124 15.6788 0 14.1813 0H2.81865C1.32124 0 0 1.32124 0 2.81865V14.1813C0 15.6787 1.32124 17 2.81865 17H8.54404V10.5699H6.43005V7.7513H8.54404V6.60622C8.54404 4.66839 9.95337 2.99481 11.715 2.99481H14.0052V5.81346H11.715C11.4508 5.81346 11.1865 6.07772 11.1865 6.60622V7.7513H14.0052V10.5699H11.1865V17H14.1813C15.6788 17 17 15.6787 17 14.1813V2.81865Z"
      fill="#4E6297"
    />
  </svg>
);

export const INSTAGRAM_ICON_SVG = (
  <svg
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.5808 0H2.41923C1.04615 0 0 1.04615 0 2.41923V14.5808C0 15.9538 1.04615 17 2.41923 17H14.5808C15.9538 17 17 15.9538 17 14.5808V2.41923C17 1.04615 15.9538 0 14.5808 0ZM8.5 13.6C11.3115 13.6 13.6 11.3769 13.6 8.69615C13.6 8.51712 13.59 8.32808 13.57 8.14078C13.5263 7.73185 13.8285 7.32308 14.2398 7.32308C14.5725 7.32308 14.8423 7.59283 14.8423 7.92559V14.2538C14.8423 14.5808 14.5808 14.9077 14.1885 14.9077H2.81154C2.48462 14.9077 2.15769 14.6462 2.15769 14.2538V7.9043C2.15769 7.54719 2.44719 7.25769 2.80431 7.25769C3.2339 7.25769 3.54234 7.67059 3.49497 8.09757C3.47525 8.2753 3.46539 8.45304 3.46539 8.63077C3.4 11.3769 5.68846 13.6 8.5 13.6ZM8.5 11.6385C6.66923 11.6385 5.23077 10.2 5.23077 8.43462C5.23077 6.66923 6.66923 5.23077 8.5 5.23077C10.3308 5.23077 11.7692 6.66923 11.7692 8.43462C11.7692 10.2654 10.3308 11.6385 8.5 11.6385ZM14.7769 4.64231C14.7769 5.03461 14.45 5.36154 14.0577 5.36154H12.2269C11.8346 5.36154 11.5077 5.03461 11.5077 4.64231V2.87692C11.5077 2.48462 11.8346 2.15769 12.2269 2.15769H14.0577C14.45 2.15769 14.7769 2.48462 14.7769 2.87692V4.64231Z"
      fill="url(#paint0_linear)"
    />
    <defs>
      <linearGradient
        id="paint0_linear"
        x1="17"
        y1="-9.83477e-07"
        x2="0.5"
        y2="17"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#EEA054" />
        <stop offset="0.505208" stopColor="#D64763" />
        <stop offset="1" stopColor="#B62A99" />
      </linearGradient>
    </defs>
  </svg>
);

export const LINKEDIN_ICON_SVG = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="17"
    height="17"
    viewBox="0 0 24 24"
  >
    <path
      fill="#0077B7"
      d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"
    />
  </svg>
);

export const VIBER_ICON_SVG = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="17"
    height="17"
    viewBox="0 0 24 24"
  >
    <path
      xmlns="http://www.w3.org/2000/svg"
      d="M11.398.002C9.473.028 5.331.344 3.014 2.467 1.294 4.177.693 6.698.623 9.82c-.06 3.11-.13 8.95 5.5 10.541v2.42s-.038.97.602 1.17c.79.25 1.24-.499 1.99-1.299l1.4-1.58c3.85.32 6.8-.419 7.14-.529.78-.25 5.181-.811 5.901-6.652.74-6.031-.36-9.831-2.34-11.551l-.01-.002c-.6-.55-3-2.3-8.37-2.32 0 0-.396-.025-1.038-.016zm.067 1.697c.545-.003.88.02.88.02 4.54.01 6.711 1.38 7.221 1.84 1.67 1.429 2.528 4.856 1.9 9.892-.6 4.88-4.17 5.19-4.83 5.4-.28.09-2.88.73-6.152.52 0 0-2.439 2.941-3.199 3.701-.12.13-.26.17-.35.15-.13-.03-.17-.19-.16-.41l.02-4.019c-4.771-1.32-4.491-6.302-4.441-8.902.06-2.6.55-4.732 2-6.172 1.957-1.77 5.475-2.01 7.11-2.02zm.36 2.6a.299.299 0 0 0-.3.299.3.3 0 0 0 .3.3 5.631 5.631 0 0 1 4.03 1.59c1.09 1.06 1.621 2.48 1.641 4.34a.3.3 0 0 0 .3.3v-.009a.3.3 0 0 0 .3-.3 6.451 6.451 0 0 0-1.81-4.76c-1.19-1.16-2.692-1.76-4.462-1.76zm-3.954.69a.955.955 0 0 0-.615.12h-.012c-.41.24-.788.54-1.148.94-.27.32-.421.639-.461.949a1.24 1.24 0 0 0 .05.541l.02.01a13.722 13.722 0 0 0 1.2 2.6 15.383 15.383 0 0 0 2.32 3.171l.03.04.04.03.03.03.03.03a15.603 15.603 0 0 0 3.18 2.33c1.32.72 2.122 1.06 2.602 1.2v.01c.14.04.268.06.398.06a1.84 1.84 0 0 0 1.102-.472c.39-.35.7-.738.93-1.148v-.01c.23-.43.15-.841-.18-1.121a13.632 13.632 0 0 0-2.15-1.54c-.51-.28-1.03-.11-1.24.17l-.45.569c-.23.28-.65.24-.65.24l-.012.01c-3.12-.8-3.95-3.959-3.95-3.959s-.04-.43.25-.65l.56-.45c.27-.22.46-.74.17-1.25a13.522 13.522 0 0 0-1.54-2.15.843.843 0 0 0-.504-.3zm4.473.89a.3.3 0 0 0 .002.6 3.78 3.78 0 0 1 2.65 1.15 3.5 3.5 0 0 1 .9 2.57.3.3 0 0 0 .3.299l.01.012a.3.3 0 0 0 .3-.301c.03-1.19-.34-2.19-1.07-2.99-.73-.8-1.75-1.25-3.05-1.34a.3.3 0 0 0-.042 0zm.49 1.619a.305.305 0 0 0-.018.611c.99.05 1.47.55 1.53 1.58a.3.3 0 0 0 .3.29h.01a.3.3 0 0 0 .29-.32c-.07-1.34-.8-2.091-2.1-2.161a.305.305 0 0 0-.012 0z"
    />
  </svg>
);

export const TIKTOK_ICON_SVG = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="17"
    height="17"
    viewBox="0 0 24 24"
  >
    <path
      xmlns="http://www.w3.org/2000/svg"
      d="M12.53.02C13.84 0 15.14.01 16.44 0c.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z"
    />
  </svg>
);

export const HEADER_BACKGROUND_SVG = (
  <svg
    width="1195"
    height="588"
    viewBox="0 0 1195 588"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1339.06 -279.695C1311.92 -252.458 1288.17 -225.22 1261.04 -201.388C1294.96 -136.698 1281.39 -54.9857 1227.11 2.8941L826.839 408.053C758.996 476.146 647.055 476.146 579.211 408.053L178.936 2.8941C111.093 -65.1998 111.093 -177.555 178.936 -245.649L582.604 -647.402C650.447 -715.496 762.388 -715.496 830.231 -647.402L1054.11 -422.693C1084.64 -443.121 1111.78 -460.144 1142.31 -477.168L857.369 -763.162C772.565 -848.279 640.27 -848.279 555.466 -763.162L63.603 -272.886C-21.201 -187.769 -21.201 -54.9857 63.603 30.1317L552.074 523.812C636.878 608.93 769.172 608.93 853.976 523.812L1342.45 30.1317C1427.25 -54.9857 1427.25 -187.769 1342.45 -272.886L1339.06 -279.695Z"
      fill="#DA052C"
    />
    <path
      d="M345.087 -498.407L49.2981 -186.245L279.356 175.207L591.577 503.8L788.769 520.229L1133.86 175.207L1347.48 -54.8076V-268.393L1117.42 -498.407L969.529 -596.985L755.904 -711.993H608.01L509.413 -629.844L345.087 -498.407Z"
      fill="#DA052C"
    />
  </svg>
);

export const PRICE_CHECK_SVG = (
  <svg
    width="10"
    height="8"
    viewBox="0 0 10 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.62326 0.192951C10.0465 0.505514 10.1249 1.0874 9.79849 1.49263L4.84709 7.63931C4.67734 7.85004 4.42116 7.98071 4.14381 7.99803C3.86646 8.01536 3.59472 7.91766 3.39782 7.72983L0.28474 4.76023C-0.0938995 4.39904 -0.0950591 3.81233 0.28215 3.44977C0.659359 3.08722 1.2721 3.08611 1.65074 3.44729L3.98552 5.67447L8.26594 0.360735C8.59237 -0.0444924 9.20006 -0.119612 9.62326 0.192951Z"
      fill="white"
    />
  </svg>
);

export const HEADER_BODY_SVG = [
  <svg
    width="17"
    height="21"
    viewBox="0 0 17 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.49243 1.83864L9.95273 2.625H10.872H12.2188V4.2H4.78128V2.625H6.12807H7.04733L7.50763 1.83864C7.60189 1.67761 7.77415 1.575 7.96878 1.575H9.03128C9.22591 1.575 9.39817 1.67761 9.49243 1.83864ZM4.25003 1.05H6.12807C6.49549 0.422309 7.18223 0 7.96878 0H9.03128C9.81783 0 10.5046 0.422309 10.872 1.05H12.75C13.3368 1.05 13.8125 1.5201 13.8125 2.1H14.875C16.0486 2.1 17 3.0402 17 4.2V7.35V18.9C17 20.0598 16.0486 21 14.875 21H2.12503C0.951425 21 3.05176e-05 20.0598 3.05176e-05 18.9V4.2C3.05176e-05 3.0402 0.951425 2.1 2.12503 2.1H3.18753C3.18753 1.5201 3.66323 1.05 4.25003 1.05ZM13.8125 3.675V4.725C13.8125 5.3049 13.3368 5.775 12.75 5.775H4.25003C3.66323 5.775 3.18753 5.3049 3.18753 4.725V3.675H2.12503C1.83163 3.675 1.59378 3.91005 1.59378 4.2V18.9C1.59378 19.1899 1.83163 19.425 2.12503 19.425H14.875C15.1684 19.425 15.4063 19.1899 15.4063 18.9V7.35V4.2C15.4063 3.91005 15.1684 3.675 14.875 3.675H13.8125ZM3.18753 9.1875C3.18753 8.75258 3.5443 8.4 3.98441 8.4H7.70316C8.14326 8.4 8.50003 8.75258 8.50003 9.1875C8.50003 9.62242 8.14326 9.975 7.70316 9.975H3.98441C3.5443 9.975 3.18753 9.62242 3.18753 9.1875ZM3.98441 11.55C3.5443 11.55 3.18753 11.9026 3.18753 12.3375C3.18753 12.7724 3.5443 13.125 3.98441 13.125H13.0157C13.4558 13.125 13.8125 12.7724 13.8125 12.3375C13.8125 11.9026 13.4558 11.55 13.0157 11.55H3.98441ZM3.18753 15.4875C3.18753 15.0526 3.5443 14.7 3.98441 14.7H13.0157C13.4558 14.7 13.8125 15.0526 13.8125 15.4875C13.8125 15.9224 13.4558 16.275 13.0157 16.275H3.98441C3.5443 16.275 3.18753 15.9224 3.18753 15.4875Z"
      fill="#DA052C"
    />
  </svg>,
  <svg
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.1985 1.66118L15.3388 3.80148C15.5358 3.99849 15.5358 4.3179 15.3388 4.51491L13.912 5.94177L11.0582 3.08804L12.4851 1.66118C12.6821 1.46417 13.0015 1.46417 13.1985 1.66118ZM9.98807 4.15819L1.51342 12.6328L1.51342 15.4866L4.36716 15.4866L12.8418 7.01192L9.98807 4.15819ZM11.4149 0.591028C12.203 -0.197009 13.4806 -0.197009 14.2687 0.591028L16.409 2.73133C17.197 3.51936 17.197 4.79703 16.409 5.58506L5.28955 16.7045C5.10033 16.8937 4.84371 17 4.57612 17L1.00895 17C0.45172 17 0 16.5483 0 15.9911V12.4239C0 12.1563 0.106299 11.8997 0.295513 11.7105L11.4149 0.591028Z"
      fill="#DA052C"
    />
  </svg>,
  <svg
    width="21"
    height="16"
    viewBox="0 0 21 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.3375 1H2.6625C1.7459 1 1 1.77553 1 2.72854V13.2715C1 14.2245 1.7459 15 2.6625 15H18.3375C19.2541 15 20 14.2245 20 13.2715V2.72854C20 1.77553 19.2541 1 18.3375 1ZM19.525 6.55192H1.475V3.94946H19.525V6.55192ZM18.3375 14.5061H2.6625C2.00752 14.5061 1.475 13.9522 1.475 13.2715V7.04578H19.525V13.2715C19.525 13.9522 18.9925 14.5061 18.3375 14.5061ZM19.525 3.4556H1.475V2.72854C1.475 2.04778 2.00752 1.49387 2.6625 1.49387H18.3375C18.9925 1.49387 19.525 2.04778 19.525 2.72854V3.4556Z"
      fill="#DA052C"
      stroke="#DA052C"
    />
  </svg>,
];

export const ACTIVITY_DROPDOWN_SVG = (
  <svg
    width="11"
    height="5"
    viewBox="0 0 11 5"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.7075 5L5.5 1.90958L1.2925 5L0 4.04858L5.5 0L11 4.04858L9.7075 5Z"
      fill="#DA052C"
    />
  </svg>
);

export const CLOSE_SVG_GREY = (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.6554 0.344595C13.1959 -0.114864 12.451 -0.114864 11.9916 0.344595L7 5.33615L2.00845 0.344595C1.54899 -0.114865 0.804055 -0.114865 0.344596 0.344595C-0.114864 0.804054 -0.114864 1.54899 0.344595 2.00845L5.33615 7L0.344595 11.9916C-0.114865 12.451 -0.114865 13.1959 0.344595 13.6554C0.804055 14.1149 1.54899 14.1149 2.00845 13.6554L7 8.66385L11.9916 13.6554C12.451 14.1149 13.1959 14.1149 13.6554 13.6554C14.1149 13.1959 14.1149 12.451 13.6554 11.9916L8.66385 7L13.6554 2.00845C14.1149 1.54899 14.1149 0.804056 13.6554 0.344595Z"
      fill="#CACACA"
    />
  </svg>
);
